import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useEditor } from '@splashthat/splash-cms-engine';
import { useModal } from 'common/components/TouchpointEditor/contexts/ModalManager';

export default function Portal({ portal }) {
    const editor = useEditor((state) => ({
        nodes: state.nodes,
        editing: state.editing,
    }));

    const modal = useModal();

    useEffect(() => {
        const rsvpModal = Object.values(editor.nodes).find((node) => node.type === 'Modal');
        rsvpModal?.id && modal.open(rsvpModal.id);
    }, [editor.nodes]);

    return <div ref={portal} />;
}

Portal.propTypes = {
    portal: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }).isRequired,
};
